module.exports = __webpack_public_path__ + "static/media/equalicare-img17b.4003c4b0.png";